import { render, staticRenderFns } from "./boardDetail.vue?vue&type=template&id=d733982a"
import script from "./boardDetail.vue?vue&type=script&lang=js"
export * from "./boardDetail.vue?vue&type=script&lang=js"
import style0 from "./boardDetail.vue?vue&type=style&index=0&id=d733982a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports